import { useCallback, useContext, useEffect, useState } from "react";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { useFormik } from "formik";
import * as Yup from "yup";
import { TostMsg } from "../../../../App";
import {
  addEmployeeAddress,
  deleteEmployeeAddress,
  getEmployeeAddress,
} from "../Service/profileService";
import { GetMasterTypeData } from "../../../../Services/Global-Services/GlobalServices";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { Dropdown } from "bootstrap/dist/js/bootstrap.bundle.min";

const AddressInfo = ({ employeeId, employee }) => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [employeeCreate, setEmployeeCreate] = useState(false);
  const [Isloading, setIsloading] = useState(false);
  const [addressData, setAddressData] = useState([]);
  const toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [showContent, setSeleteContent] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [addressId, setAddressId] = useState(0);
  const [countriesList, setCountriesList] = useState(null);
  const defaultImage = "/images/org-img/profile/badge.png";
  const [noData, setNoData] = useState([]);

  useEffect(() => {
    permissionAccouncementList();
    GetMasterSystemAlertList("Employee_MissingInfo_Message", 1);
    setTimeout(() => {
      getCountries();
    }, 1000);
    if (employeeId) {
      employeeAddresssList();
    }
  }, [employeeId]);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setNoData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Employee.Create") {
        setEmployeeCreate(true);
      }
    });
  };

  const getCountries = async () => {
    let params = {
      masterType: "Countries",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };
    try {
      let responce = await GetMasterTypeData(params);
      setCountriesList(responce?.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST?.DashboardCountries);
    }
  };

  const handleCloseModal = () => {
    AddressForm.resetForm();
  };

  async function employeeAddresssList() {
    const params = {
      OrgId: userDetails.OrgId,
      EmpId: employeeId,
    };
    try {
      const response = await getEmployeeAddress(params);
      let AddressDatalist = response?.Data[0];
      setAddressData(AddressDatalist);
      const editAddressDetails = {
        id: AddressDatalist?.id,
        addressTypeId: AddressDatalist?.AddressTypeId ?? 0,
        address1: AddressDatalist?.Address1,
        address2: AddressDatalist?.Address2,
        city: AddressDatalist?.City,
        state: AddressDatalist?.State,
        countryId: AddressDatalist?.CountryId,
        pincode: AddressDatalist?.PINCODE,
        empId: AddressDatalist?.EmpId,
        orgId: AddressDatalist?.OrgId,
      };
      AddressForm.setValues(editAddressDetails);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setIsloading(false);
    }
  }

  const infoValidation = Yup.object().shape({
    address1: Yup.string().required("Address is required."),
    address2: Yup.string().required("Address is required."),
    city: Yup.string().required("City is required."),
    state: Yup.string().required("State is required."),
    pincode: Yup.string().required("Pincode is required."),
    countryId: Yup.string().required("Country is required."),
  });

  const AddressForm = useFormik({
    initialValues: {
      addressTypeId: 0,
      address1: "",
      address2: "",
      city: "",
      state: "",
      countryId: "",
      pincode: "",
    },
    validationSchema: infoValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      const body = {
        Id: data?.id ?? 0,
        OrgId: data?.orgId ?? userDetails.OrgId,
        EmpId: data?.empId ?? employeeId,
        AddressTypeId: data?.addressTypeId ?? 0,
        Address1: data?.address1 ?? "",
        Address2: data?.address2 ?? "",
        City: data?.city ?? "",
        State: data?.state ?? "",
        CountryId: Number(data?.countryId) ?? 0,
        PINCODE: data?.pincode ?? "",
        IsDefault: true,
        ModifiedBy: data?.empId ?? userDetails.EmpId,
      };
      try {
        await addEmployeeAddress(body);
        setIsloading(false);
        if (data?.id != 0) {
          GetMasterSystemAlertList("Address_Added", 0);
        } else {
          GetMasterSystemAlertList("Address_Updated", 0);
        }
        employeeAddresssList();
        setIsEditing(false);
        const tabTriggerEl = document.querySelector('a[href="#my-posts"]');
        if (tabTriggerEl) {
          const tab = new window.bootstrap.Tab(tabTriggerEl);
          tab.show();
        }
      } catch (err) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    },
  });

  async function deleteAddress() {
    setIsloading(true);
    if (addressId) {
      const body = {
        Id: addressId,
        ModifiedBy: userDetails.EmpId,
      };
      try {
        setIsloading(false);
        let response = await deleteEmployeeAddress(body);
        if (response) {
          GetMasterSystemAlertList("Address_deleted", 0);
          employeeAddresssList();
          setIsloading(false);
        }
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  return (
    <div className="documentdiv">
      <form onSubmit={AddressForm.handleSubmit} id="address-form">
        <div className="">
          <h4 className="text-primary mb-3 sumh4"> Address</h4>
          {addressData ? (
            <>
              {!isEditing ? (
                <div className="address-actionbtns">
                  <span
                    className="edit-btncss mb-2 love-icon"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Edit"
                    onClick={() => setIsEditing(true)}
                  >
                    <LazyImage
                      src="/images/org-img/edit.png"
                      className="w-100"
                    />
                  </span>
                </div>
              ) : (
                <div className="address-actionbtns">
                  <span
                    className="edit-btncss mb-2 love-icon"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Cancel"
                    onClick={() => {
                      setIsEditing(false);
                      employeeAddresssList();
                    }}
                  >
                    <LazyImage
                      src="/images/org-img/profile/close.png"
                      className="w-100"
                    />
                  </span>
                </div>
              )}
            </>
          ) : (
            <div className="address-actionbtns">
              {!isAdd ? (
                <span
                  className="edit-btncss mb-2 love-icon"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Add"
                  onClick={() => setIsAdd(true)}
                >
                  <LazyImage
                    src="/images/org-img/profile/add.png"
                    className="w-100"
                  />
                </span>
              ) : (
                <>
                  <span
                    className="edit-btncss mb-2 love-icon"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Cancel"
                    onClick={() => {
                      setIsAdd(false);
                      handleCloseModal();
                    }}
                  >
                    <LazyImage
                      src="/images/org-img/profile/close.png"
                      className="w-100"
                    />
                  </span>
                </>
              )}
            </div>
          )}
          <div className="row gy-1 gx-2">
            {addressData ? (
              <>
                <div className="col-lg-6 mb-2">
                  <div className="mb-2">
                    <label>
                      House/Flat/Block & Street<i className="inValidError">*</i>
                    </label>
                    <input
                      disabled={!isEditing}
                      type="text"
                      name="address1"
                      className={
                        "form-control" +
                        (AddressForm.errors.address1 &&
                        AddressForm.touched.address1
                          ? " is-invalid"
                          : "")
                      }
                      onChange={AddressForm.handleChange}
                      value={AddressForm.values.address1}
                    />
                  </div>
                  <div className="invalid-feedback">
                    {AddressForm.errors.address1 && AddressForm.touched.address1
                      ? AddressForm.errors.address1
                      : null}
                  </div>
                </div>
                <div className="col-lg-6 mb-2">
                  <div className="mb-2">
                    <label>Area/Locality & Landmark </label>
                    <input
                      disabled={!isEditing}
                      type="text"
                      name="address2"
                      className="form-control"
                      onChange={AddressForm.handleChange}
                      value={AddressForm.values.address2}
                    />
                  </div>
                </div>
                <div className="col-lg-6 mb-2">
                  <div className="mb-2">
                    <label>
                      City<i className="inValidError">*</i>
                    </label>
                    <input
                      disabled={!isEditing}
                      type="text"
                      name="city"
                      className={
                        "form-control" +
                        (AddressForm.errors.city && AddressForm.touched.city
                          ? " is-invalid"
                          : "")
                      }
                      onChange={AddressForm.handleChange}
                      value={AddressForm.values.city}
                    />
                  </div>
                  <div className="invalid-feedback">
                    {AddressForm.errors.city && AddressForm.touched.city
                      ? AddressForm.errors.city
                      : null}
                  </div>
                </div>
                <div className="col-lg-6 mb-2">
                  <div className="mb-2">
                    <label>
                      State<i className="inValidError">*</i>
                    </label>
                    <input
                      disabled={!isEditing}
                      type="text"
                      name="state"
                      className={
                        "form-control" +
                        (AddressForm.errors.state && AddressForm.touched.state
                          ? " is-invalid"
                          : "")
                      }
                      onChange={AddressForm.handleChange}
                      value={AddressForm.values.state}
                    />
                  </div>
                  <div className="invalid-feedback">
                    {AddressForm.errors.state && AddressForm.touched.state
                      ? AddressForm.errors.state
                      : null}
                  </div>
                </div>
                <div className="col-lg-6 mb-2">
                  <div className="mb-2">
                    <label>
                      Pin Code<i className="inValidError">*</i>
                    </label>
                    <input
                      disabled={!isEditing}
                      type="text"
                      name="pincode"
                      className={
                        "form-control" +
                        (AddressForm.errors.pincode &&
                        AddressForm.touched.pincode
                          ? " is-invalid"
                          : "")
                      }
                      onChange={AddressForm.handleChange}
                      value={AddressForm.values.pincode}
                    />
                  </div>
                  <div className="invalid-feedback">
                    {AddressForm.errors.pincode && AddressForm.touched.pincode
                      ? AddressForm.errors.pincode
                      : null}
                  </div>
                </div>
                {!isEditing ? (
                  <div className="col-lg-6 mb-2">
                    <div className="mb-2">
                      <label>
                        Country<i className="inValidError">*</i>
                      </label>

                      <input
                        disabled={!isEditing}
                        type="text"
                        name="state"
                        className="form-control"
                        value={addressData?.CountryName}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-6 mb-2">
                    <div className="mb-2">
                      <label>
                        Country<i className="inValidError">*</i>
                      </label>
                      <select
                        id="inputState"
                        name="countryId"
                        className={
                          "default-select form-control wide" +
                          (AddressForm.errors.countryId &&
                          AddressForm.touched.countryId
                            ? " is-invalid"
                            : "")
                        }
                        onChange={AddressForm.handleChange}
                        value={AddressForm.values.countryId}
                        placeholder="Country Name"
                      >
                        <option value="" disabled selected>
                          Please Select...
                        </option>
                        {countriesList?.map((option) => (
                          <option key={option.Id} value={option.Id}>
                            {option.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="invalid-feedback">
                      {AddressForm.errors.countryId &&
                      AddressForm.touched.countryId
                        ? AddressForm.errors.countryId
                        : null}
                    </div>
                  </div>
                )}
                {isEditing && (
                  <div className="col-md-12">
                    <div className="btns-grp text-right">
                      <button
                        type="submit"
                        className="savebtn-click"
                        disabled={Isloading}
                      >
                        {Isloading ? "Save & exit" : "Save & exit"}
                      </button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div style={{ textAlign: "center" }}>{!isAdd && <>{noData}</>}</div>
            )}
            {isAdd && !addressData && (
              <>
                <div className="col-lg-6 mb-2">
                  <div className="mb-2">
                    <label>
                      Address<i className="inValidError">*</i>
                    </label>
                    <input
                      type="text"
                      name="address1"
                      className={
                        "form-control" +
                        (AddressForm.errors.address1 &&
                        AddressForm.touched.address1
                          ? " is-invalid"
                          : "")
                      }
                      onChange={AddressForm.handleChange}
                      value={AddressForm.values.address1}
                    />
                  </div>
                  <div className="invalid-feedback">
                    {AddressForm.errors.address1 && AddressForm.touched.address1
                      ? AddressForm.errors.address1
                      : null}
                  </div>
                </div>
                <div className="col-lg-6 mb-2">
                  <div className="mb-2">
                    <label>Address 2</label>
                    <input
                      type="text"
                      name="address2"
                      className="form-control"
                      onChange={AddressForm.handleChange}
                      value={AddressForm.values.address2}
                    />
                  </div>
                </div>
                <div className="col-lg-6 mb-2">
                  <div className="mb-2">
                    <label>
                      City<i className="inValidError">*</i>
                    </label>
                    <input
                      type="text"
                      name="city"
                      className={
                        "form-control" +
                        (AddressForm.errors.city && AddressForm.touched.city
                          ? " is-invalid"
                          : "")
                      }
                      onChange={AddressForm.handleChange}
                      value={AddressForm.values.city}
                    />
                  </div>
                  <div className="invalid-feedback">
                    {AddressForm.errors.city && AddressForm.touched.city
                      ? AddressForm.errors.city
                      : null}
                  </div>
                </div>
                <div className="col-lg-6 mb-2">
                  <div className="mb-2">
                    <label>
                      State<i className="inValidError">*</i>
                    </label>
                    <input
                      type="text"
                      name="state"
                      className={
                        "form-control" +
                        (AddressForm.errors.state && AddressForm.touched.state
                          ? " is-invalid"
                          : "")
                      }
                      onChange={AddressForm.handleChange}
                      value={AddressForm.values.state}
                    />
                  </div>
                  <div className="invalid-feedback">
                    {AddressForm.errors.state && AddressForm.touched.state
                      ? AddressForm.errors.state
                      : null}
                  </div>
                </div>
                <div className="col-lg-6 mb-2">
                  <div className="mb-2">
                    <label>
                      Pin Code<i className="inValidError">*</i>
                    </label>
                    <input
                      type="text"
                      name="pincode"
                      className={
                        "form-control" +
                        (AddressForm.errors.pincode &&
                        AddressForm.touched.pincode
                          ? " is-invalid"
                          : "")
                      }
                      onChange={AddressForm.handleChange}
                      value={AddressForm.values.pincode}
                    />
                  </div>
                  <div className="invalid-feedback">
                    {AddressForm.errors.pincode && AddressForm.touched.pincode
                      ? AddressForm.errors.pincode
                      : null}
                  </div>
                </div>
                <div className="col-lg-6 mb-2">
                  <div className="mb-2">
                    <label>
                      Country<i className="inValidError">*</i>
                    </label>
                    <select
                      id="inputState"
                      name="countryId"
                      className={
                        "default-select form-control wide" +
                        (AddressForm.errors.countryId &&
                        AddressForm.touched.countryId
                          ? " is-invalid"
                          : "")
                      }
                      onChange={AddressForm.handleChange}
                      value={AddressForm.values.countryId}
                      placeholder="Country Name"
                    >
                      <option value="" disabled selected>
                        Please Select...
                      </option>
                      {countriesList?.map((option) => (
                        <option key={option.Id} value={option.Id}>
                          {option.Name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="invalid-feedback">
                    {AddressForm.errors.countryId &&
                    AddressForm.touched.countryId
                      ? AddressForm.errors.countryId
                      : null}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="btns-grp text-right">
                    <button
                      type="submit"
                      className="savebtn-click"
                      disabled={Isloading}
                    >
                      {Isloading ? "Save & exit" : "Save & exit"}
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </form>
      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>Do you really want to delete this Badge?</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteAddress()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressInfo;
